import { render, staticRenderFns } from "./TileBox.vue?vue&type=template&id=3d26ca0b"
import script from "./TileBox.vue?vue&type=script&lang=js"
export * from "./TileBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports